import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/audit/$id')({
  beforeLoad: () => getAuditLogsTitleContextSlice(true),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
